var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "spiner" },
    [
      _c(
        "svg",
        { staticClass: "circular", attrs: { viewBox: "25 25 50 50" } },
        [
          _c("circle", {
            staticClass: "path",
            style: { stroke: _vm.color },
            attrs: { cx: "50", cy: "50", r: "20", fill: "none" },
          }),
        ]
      ),
      _vm._t("default", function () {
        return [
          _c(
            "span",
            { staticClass: "spinner-text", style: { color: _vm.color } },
            [_vm._v(_vm._s(_vm.text))]
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }